export default __webpack_public_path__ + "static/media/circleGrey.21c168a0.svg";